import isClick from '../../assets/scripts/utils/click';
import { slideUp, slideDown } from '../../assets/scripts/utils/slide';
// const collapseAll = (parentEl: HTMLElement) => {
//   if (!parentEl) return;
//   const speed = 400;
//   parentEl.querySelectorAll('.expand-btn').forEach((toggle) => {
//     const collapseId = toggle.getAttribute('aria-controls') ?? '';
//     const collapse = document.querySelector(`#${collapseId}`);
//     if (collapse?.classList.contains('show')) {
//       collapse.classList.add('is-collapsing');
//       toggle.setAttribute('aria-expanded', 'false');
//       slideUp(collapse as HTMLElement, speed, () => {
//         collapse.classList.remove('is-collapsing');
//         collapse.classList.remove('show');
//       });
//     }
//   });
// };
const handleCollapseToggleClick = (event) => {
    var _a, _b;
    const speed = 400;
    const toggle = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('.expand-btn');
    if (toggle) {
        const typeAttr = toggle.getAttribute('type') || '';
        const isChecked = (isClick(event) === true);
        if (isChecked) {
            if ((typeAttr !== 'checkbox') && (typeAttr !== 'radio')) {
                event.preventDefault();
            }
            const collapseId = (_b = toggle.getAttribute('aria-controls')) !== null && _b !== void 0 ? _b : '';
            const collapse = document.querySelector(`#${collapseId}`);
            if (collapse && !collapse.classList.contains('is-collapsing')) {
                if (toggle.getAttribute('aria-expanded') === 'true') {
                    collapse.classList.add('is-collapsing');
                    toggle.setAttribute('aria-expanded', 'false');
                    slideUp(collapse, speed, () => {
                        collapse.classList.remove('is-collapsing');
                        collapse.classList.remove('show');
                    });
                }
                else {
                    // const parentSelector = collapse.getAttribute('data-parent') || '';
                    // if (parentSelector) {
                    //   const parent = document.querySelector(parentSelector);
                    //   if (parent) {
                    //     collapseAll(parent as HTMLElement);
                    //   }
                    // }
                    collapse.classList.add('is-collapsing');
                    toggle.setAttribute('aria-expanded', 'true');
                    slideDown(collapse, speed, () => {
                        collapse.classList.remove('is-collapsing');
                        collapse.classList.add('show');
                    });
                }
            }
        }
    }
};
export const initCollapse = () => {
    document.addEventListener('click', handleCollapseToggleClick);
    document.addEventListener('keypress', handleCollapseToggleClick);
};
initCollapse();
